import { render, staticRenderFns } from "./BAuth.vue?vue&type=template&id=6b41f7b4"
import script from "./BAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./BAuth.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports